import {isBrowserContext} from 'core/helpers';
import {CookieService} from 'core/services/CookieService';
import {InitialContextService, ContextService} from 'core/services/ContextService';
import {buildHeadersWithCookies} from 'core/helpers/api/headers';

interface IGetRequestCookieHeader {
    Cookie: string;
}

export const getRequestCookieHeader = (): IGetRequestCookieHeader | null => {
    if (isBrowserContext()) {
        return null;
    }

    // контекст в зависимости от того, где выполняется код getInitialProps/getServerSideProps
    const req = ContextService.req || InitialContextService.req;

    if (!req?.headers?.cookie) {
        const cookieService = CookieService.getInstance();
        const allCookies = cookieService.getAll();
        const cookieString = Object.entries(allCookies)
            .filter(([_, value]) => null !== value && '' !== value)
            .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
            .join('; ');

        return cookieString ? {Cookie: cookieString} : null;
    }

    return {
        Cookie: req.headers.cookie,
    };
};

export const getListHeadersWithCookies = () => {
    const cookieHeader = getRequestCookieHeader();
    return buildHeadersWithCookies({withSeo: 'list'}, cookieHeader as Record<string, string> | null);
};
